import Products_D_0 from './Products_D/Products_D_0'
import Products_D_1 from './Products_D/Products_D_1'
import Products_D_2 from './Products_D/Products_D_2'
import Products_D_3 from './Products_D/Products_D_3'
import Products_D_4 from './Products_D/Products_D_4'
import Products_D_5 from './Products_D/Products_D_5'
import Products_D_6 from './Products_D/Products_D_6'
import Products_D_7 from './Products_D/Products_D_7'
import Products_D_8 from './Products_D/Products_D_8'
import Products_D_9 from './Products_D/Products_D_9'
import Products_D_10 from './Products_D/Products_D_10'
import Products_D_11 from './Products_D/Products_D_11'

const Products_D = [
  Products_D_0,
  Products_D_1,
  Products_D_2,
  Products_D_3,
  Products_D_4,
  Products_D_5,
  Products_D_6,
  Products_D_7,
  Products_D_8,
  Products_D_9,
  Products_D_10,
  Products_D_11
]
export default Products_D



// WEBPACK FOOTER //
// ./src/components/Products_D.js